/* Massimo Castelli - "My collection" (09.10.2026, print / save PDF button and base prices for logged-in customers 12.10.2026)
   19.10.2026: quote request only for logged-in customers; logo mould line (one-off 120 EUR, about 1 week) and lead time
   (14 days, about 30 days with a new mould); no packaging / target price / deadline prompts; the request email
   contains a link that opens the same printable collection (data inside the link, #mcc=...).
   Site-wide floating button + side drawer with the private label selection and the quote request.
   Storage: localStorage (this browser only). Request: posted to the Shopify contact form (/contact). */
(function () {
  if (window.MCCollection) return;
  var KEY = 'mc_pl_collection_v1';
  var SENT = 'mc_pl_sent';
  var MKEY = 'mc_pl_has_mould';
  var MOULD = 120;
  var CDN = 'https://cdn.shopify.com/s/files/';
  var listeners = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var coll = load();
  var hasMould = false;
  try { hasMould = localStorage.getItem(MKEY) === '1'; } catch (e) {}

  /* a request sent from the drawer comes back with ?contact_posted=true */
  var justSent = false;
  try {
    if (/[?&]contact_posted=true/.test(location.search) && sessionStorage.getItem(SENT)) {
      sessionStorage.removeItem(SENT); coll = []; save(coll); justSent = true;
    }
  } catch (e) {}

  var css = '' +
    '.mcc-fab{position:fixed;right:2rem;bottom:2rem;z-index:60;display:flex;align-items:center;gap:.8rem;background:#111;color:#fff;border:0;border-radius:999px;padding:1.3rem 2rem;font-size:1.4rem;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.25);cursor:pointer;transition:transform .2s}' +
    '.mcc-fab:hover{transform:translateY(-2px)}.mcc-fab[hidden]{display:none}' +
    '.mcc-fab b{background:#f3efe9;color:#111;border-radius:999px;min-width:2.4rem;height:2.4rem;display:inline-flex;align-items:center;justify-content:center;font-size:1.25rem;padding:0 .6rem}' +
    '.mcc-fab.is-bump{animation:mccb .5s}@keyframes mccb{30%{transform:scale(1.12)}}' +
    '.mcc-ov{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:70;opacity:0;pointer-events:none;transition:opacity .25s}' +
    '.mcc-ov.is-open{opacity:1;pointer-events:auto}' +
    '.mcc-dr{position:fixed;top:0;right:0;bottom:0;width:min(46rem,100%);background:#fff;color:#111;z-index:71;transform:translateX(100%);transition:transform .3s;display:flex;flex-direction:column;box-shadow:-10px 0 30px rgba(0,0,0,.15)}' +
    '.mcc-dr.is-open{transform:none}' +
    '.mcc-hd{display:flex;justify-content:space-between;align-items:center;padding:2rem 2.4rem;border-bottom:1px solid #eee}' +
    '.mcc-hd h2{font-size:2rem;margin:0;font-weight:500}.mcc-x{background:none;border:0;font-size:2.8rem;line-height:1;cursor:pointer;color:#111}' +
    '.mcc-bd{flex:1;overflow-y:auto;padding:1rem 2.4rem 2.4rem}' +
    '.mcc-row{display:flex;gap:1.2rem;align-items:center;padding:1.2rem 0;border-bottom:1px solid #eee}' +
    '.mcc-row img,.mcc-row .mcc-ph{width:6rem;height:6rem;border-radius:.8rem;object-fit:cover;background:#f3f3f3;flex:none}' +
    '.mcc-row div{flex:1;font-size:1.35rem;line-height:1.55}.mcc-row i{display:inline-block;width:1.1rem;height:1.1rem;border-radius:50%;margin-right:.4rem;vertical-align:-1px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15)}' +
    '.mcc-row button{background:none;border:0;font-size:2.2rem;cursor:pointer;opacity:.45}.mcc-row button:hover{opacity:1}' +
    '.mcc-sum{font-size:1.4rem;margin:1.4rem 0;opacity:.75}.mcc-empty{font-size:1.45rem;opacity:.65;padding:2rem 0}' +
    '.mcc-terms{background:#f6f3ef;border-radius:1rem;padding:1.2rem 1.4rem;font-size:1.3rem;line-height:1.6;margin:1.2rem 0 0}' +
    '.mcc-terms b{font-weight:600}.mcc-terms .mcc-ck{display:flex;gap:.8rem;align-items:center;margin:.8rem 0 0;cursor:pointer}.mcc-terms .mcc-ck input{width:auto;margin:0}' +
    '.mcc-f label{display:block;font-size:1.2rem;opacity:.7;margin:1.1rem 0 .3rem}' +
    '.mcc-f input,.mcc-f textarea{width:100%;box-sizing:border-box;border:1px solid #ccc;border-radius:.8rem;padding:1rem 1.2rem;font-size:1.45rem;font-family:inherit}' +
    '.mcc-go{display:block;width:100%;margin-top:1.8rem;background:#111;color:#fff;border:0;border-radius:999px;padding:1.5rem;font-size:1.45rem;font-weight:600;cursor:pointer;text-align:center;text-decoration:none;box-sizing:border-box}' +
    '.mcc-go--ghost{background:#fff;color:#111;border:1px solid #111;margin-top:1rem}' +
    '.mcc-note{font-size:1.2rem;opacity:.6;margin:1rem 0 0}.mcc-link{display:inline-block;margin-top:1.2rem;font-size:1.4rem;color:#111}' +
    '.mcc-pr{font-size:1.25rem;opacity:.85}.mcc-acts{display:flex;justify-content:space-between;align-items:center;gap:1rem;flex-wrap:wrap}.mcc-print{margin-top:1.2rem;background:none;border:1px solid #111;border-radius:999px;padding:.7rem 1.4rem;font-size:1.3rem;color:#111;cursor:pointer}.mcc-print:hover{background:#111;color:#fff}' +
    '.mcc-who{font-size:1.4rem;line-height:1.55;background:#f6f3ef;border-radius:1rem;padding:1.2rem 1.4rem;margin:1rem 0 0}' +
    '.mcc-login{margin-top:2.4rem}.mcc-login p{font-size:1.4rem;line-height:1.55;margin:0}' +
    '.mcc-ok{background:#e8f3ea;border-radius:1rem;padding:1.6rem;font-size:1.4rem;margin:1.6rem 0}' +
    '.mcc-view{position:fixed;inset:0;z-index:2147483000;width:100%;height:100%;border:0;background:#fff}' +
    '@media(max-width:549px){.mcc-fab{right:1.2rem;bottom:1.2rem}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/');
  var builderUrl = root + 'pages/private-label#mcpl';

  function build() {
    var fab = document.createElement('button');
    fab.type = 'button'; fab.className = 'mcc-fab'; fab.setAttribute('aria-label', 'Open my collection');
    fab.innerHTML = '<span>My collection</span><b>0</b>';
    var ov = document.createElement('div'); ov.className = 'mcc-ov';
    var dr = document.createElement('aside'); dr.className = 'mcc-dr'; dr.setAttribute('aria-label', 'My collection');
    dr.innerHTML = '<div class="mcc-hd"><h2>My collection</h2><button type="button" class="mcc-x" aria-label="Close">×</button></div><div class="mcc-bd"></div>';
    document.body.appendChild(fab); document.body.appendChild(ov); document.body.appendChild(dr);
    fab.addEventListener('click', open);
    ov.addEventListener('click', close);
    dr.querySelector('.mcc-x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    dr.addEventListener('click', function (e) {
      var r = e.target.closest('[data-mcc-remove]');
      if (r) { remove(+r.getAttribute('data-mcc-remove')); }
      if (e.target.closest('[data-mcc-print]')) printColl();
    });
    dr.addEventListener('change', function (e) {
      if (e.target.id === 'mcc-hasmould') {
        hasMould = !!e.target.checked;
        try { localStorage.setItem(MKEY, hasMould ? '1' : '0'); } catch (err) {}
        render();
      }
    });
    window.MCCollection._els = { fab: fab, ov: ov, dr: dr };
    render();
    if (justSent) open();
    openFromLink();
  }

  function total() { return coll.reduce(function (s, it) { return s + (+it.qty || 0); }, 0); }
  /* base bag price (B2B price list, quantity breaks 10+ / 30+), only for logged-in customers: window.MC_PL_PRICES in snippets/meta-tags.liquid */
  function unit(it) {
    var P = window.MC_PL_PRICES, r = P && P[String(it.model || '').toUpperCase()]; if (!r) return null;
    var q = +it.qty || 0;
    return q >= 30 && r.p30 ? r.p30 : (q >= 10 && r.p10 ? r.p10 : r.p);
  }
  function eur(n) { try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n); } catch (e) { return '€ ' + n.toFixed(2); } }
  function hasPrices() { return !!window.MC_PL_PRICES; }
  function logged() { var c = window.MC_CUSTOMER; return !!(c && c.email); }
  function today() {
    var d = new Date();
    return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
  }
  var PNOTE = 'Base bag price. Branding, modifications and shipping are quoted separately.';
  function mouldText(m) {
    return m ? 'Logo mould: already with us · production 14 days'
      : 'Logo mould (one-off): ' + eur(MOULD) + ', ready in about 1 week · then production: about 30 days in total';
  }

  /* one snapshot of the collection, used by the drawer print, the email link and the link view */
  function snapshot() {
    var c = window.MC_CUSTOMER || {};
    return {
      v: 1, d: today(), m: hasMould ? 1 : 0, pr: hasPrices() ? 1 : 0,
      c: c.email ? { n: c.name || '', e: c.email || '', co: c.company || '', ph: c.phone || '', cn: c.country || '' } : null,
      i: coll.map(function (it) {
        var u = unit(it), im = it.img || '';
        if (im.indexOf(CDN) === 0) im = '~' + im.slice(CDN.length);
        return [it.model || '', it.type || '', it.family || '', it.code || '', it.colour || '', it.hex || '', it.logo || '', +it.qty || 0, u || 0, im];
      })
    };
  }
  function b64e(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function b64d(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  function viewLink(snap) { return location.origin + root + '#mcc=' + b64e(JSON.stringify(snap)); }

  function line(it, i) {
    var u = unit(it);
    return (i + 1) + '. ' + it.model + (it.type ? ' (' + it.type + ')' : '') + ' - ' + it.family + ' ' +
      (it.code ? it.code + ' ' : '') + it.colour + ' - Logo: ' + it.logo + ' - ' + it.qty + ' pcs' +
      (u ? ' - base ' + eur(u) + '/pc = ' + eur(u * (+it.qty || 0)) : '');
  }
  function totals(snap) {
    var base = 0, miss = false;
    snap.i.forEach(function (r) { if (r[8]) base += r[8] * r[7]; else miss = true; });
    return { base: base, miss: miss, pcs: snap.i.reduce(function (s, r) { return s + r[7]; }, 0) };
  }
  function bodyText(snap) {
    var t = totals(snap);
    var s = 'Private label collection request\n\n' + coll.map(line).join('\n') +
      '\n\nTotal: ' + t.pcs + ' pcs' + (snap.pr && t.base ? ' - base total ' + eur(t.base) + (t.miss ? ' + items on request' : '') : '') +
      '\n' + mouldText(snap.m) +
      (snap.pr && t.base && !snap.m ? '\nEstimated total with mould: ' + eur(t.base + MOULD) + ' (excl. branding, modifications, shipping)' : '');
    return s;
  }

  /* logged-in customer: details come from the account (window.MC_CUSTOMER, set in snippets/meta-tags.liquid) */
  function who() {
    var c = window.MC_CUSTOMER;
    function h(n, v) { return '<input type="hidden" name="contact[' + n + ']" value="' + esc(v || '') + '">'; }
    return h('name', c.name) + h('email', c.email) + h('Company', c.company) + h('Country', c.country) + h('Customer account', 'Yes') +
      '<p class="mcc-who">Sending as <b>' + esc(c.name || c.email) + '</b>' + (c.company ? ' · ' + esc(c.company) : '') + '<br>' + esc(c.email) + '</p>' +
      (c.phone ? h('phone', c.phone) : '<label>Phone / WhatsApp</label><input type="tel" name="contact[phone]" autocomplete="tel">');
  }

  function render() {
    var els = window.MCCollection._els; if (!els) return;
    var n = coll.length;
    els.fab.querySelector('b').textContent = n;
    els.fab.hidden = !n && !document.getElementById('mcpl');
    var html = '';
    if (justSent) html += '<div class="mcc-ok">Thank you. We received your collection and will get back to you shortly with your quote.</div>';
    if (!n) {
      html += '<p class="mcc-empty">Your collection is empty. Configure a model, a leather and your logo finish in the collection builder.</p>' +
        '<a class="mcc-link" href="' + esc(builderUrl) + '">Open the collection builder →</a>';
    } else {
      var snap = snapshot(), t = totals(snap);
      html += coll.map(function (it, i) {
        return '<div class="mcc-row">' + (it.img ? '<img src="' + esc(sized(it.img, 160)) + '" alt="">' : '<span class="mcc-ph"></span>') +
          '<div><b>' + esc(it.model) + '</b>' + (it.type ? ' · ' + esc(it.type) : '') + '<br>' +
          (it.hex ? '<i style="background:' + esc(it.hex) + '"></i>' : '') + esc(it.family) + ' ' + esc(it.code || '') + ' ' + esc(it.colour) +
          '<br>' + esc(it.logo) + ' · <b>' + esc(it.qty) + ' pcs</b>' +
          (hasPrices() ? '<br><span class="mcc-pr">' + (unit(it) ? eur(unit(it)) + ' × ' + esc(it.qty) + ' = <b>' + eur(unit(it) * (+it.qty || 0)) + '</b>' : 'Price on request') + '</span>' : '') + '</div>' +
          '<button type="button" data-mcc-remove="' + i + '" aria-label="Remove">×</button></div>';
      }).join('');
      html += '<p class="mcc-sum">' + n + (n === 1 ? ' item' : ' items') + ' · ' + t.pcs + ' pcs' +
        (hasPrices() && t.base ? ' · base total <b>' + eur(t.base) + '</b>' + (t.miss ? ' + items on request' : '') : '') + '</p>' +
        (hasPrices() ? '<p class="mcc-note" style="margin-top:-.8rem">' + PNOTE + '</p>' : '') +
        '<div class="mcc-terms">' +
        (hasMould ? '<b>Logo mould:</b> already with us<br><b>Production:</b> 14 days'
          : '<b>Logo mould (one-off):</b> ' + eur(MOULD) + ', ready in about 1 week<br><b>Production:</b> about 30 days in total, mould included' +
            (hasPrices() && t.base ? '<br><b>Estimated total with mould:</b> ' + eur(t.base + MOULD) : '')) +
        '<label class="mcc-ck"><input type="checkbox" id="mcc-hasmould"' + (hasMould ? ' checked' : '') + '> We already have our logo mould with you</label>' +
        '</div>' +
        '<div class="mcc-acts"><a class="mcc-link" href="' + esc(builderUrl) + '">+ Add another model</a>' +
        '<button type="button" class="mcc-print" data-mcc-print>Print / Save PDF</button></div>';
      if (logged()) {
        html += '<form class="mcc-f" method="post" action="' + root + 'contact" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[Request]" value="Private label collection">' +
          '<textarea name="contact[body]" hidden>' + esc(bodyText(snap)) + '</textarea>' +
          '<input type="hidden" name="contact[Logo mould]" value="' + (snap.m ? 'Already with us' : 'New mould needed - ' + eur(MOULD) + ' one-off') + '">' +
          '<input type="hidden" name="contact[Printable collection]" value="' + esc(viewLink(snap)) + '">' +
          '<h3 style="font-size:1.8rem;font-weight:500;margin:2.4rem 0 .4rem">Request a quote</h3>' +
          who() +
          '<label>Notes</label><textarea name="contact[Notes]" rows="3"></textarea>' +
          '<button type="submit" class="mcc-go">Send request</button>' +
          '<p class="mcc-note">You can send your logo file by email or WhatsApp after submitting. Your collection is saved in this browser only.</p></form>';
      } else {
        html += '<div class="mcc-login"><h3 style="font-size:1.8rem;font-weight:500;margin:0 0 .6rem">Request a quote</h3>' +
          '<p>Log in to your business account to see your base prices and send us this collection. Your selection stays saved in this browser.</p>' +
          '<a class="mcc-go" href="' + root + 'account/login">Log in</a>' +
          '<a class="mcc-go mcc-go--ghost" href="' + root + 'account/register">Create a business account</a></div>';
      }
    }
    els.dr.querySelector('.mcc-bd').innerHTML = html;
    var f = els.dr.querySelector('.mcc-f');
    if (f) f.addEventListener('submit', function () { try { sessionStorage.setItem(SENT, '1'); } catch (e) {} });
    listeners.forEach(function (fn) { try { fn(coll); } catch (e) {} });
  }

  /* printable page (same layout for the drawer print and for the link in the request email) */
  function pageHtml(snap, viewer) {
    var t = totals(snap), c = snap.c;
    var rows = snap.i.map(function (r, i) {
      var im = r[9] && r[9].charAt(0) === '~' ? CDN + r[9].slice(1) : r[9];
      return '<tr><td class="n">' + (i + 1) + '</td><td class="im">' + (im ? '<img src="' + esc(sized(im, 500)) + '" alt="">' : '') + '</td>' +
        '<td><b>' + esc(r[0]) + '</b>' + (r[1] ? '<br><span class="m">' + esc(r[1]) + '</span>' : '') + '</td>' +
        '<td>' + (r[5] ? '<i style="background:' + esc(r[5]) + '"></i>' : '') + esc(r[2]) + ' ' + esc(r[3]) + '<br><span class="m">' + esc(r[4]) + '</span></td>' +
        '<td>' + esc(r[6]) + '</td><td class="q"><b>' + esc(r[7]) + '</b> pcs</td>' +
        (snap.pr ? '<td class="q">' + (r[8] ? eur(r[8]) : 'on request') + '</td><td class="q"><b>' + (r[8] ? eur(r[8] * r[7]) : '–') + '</b></td>' : '') + '</tr>';
    }).join('');
    var whoH = c ? '<p class="cu"><b>' + esc(c.n || c.e) + '</b>' + (c.co ? ' · ' + esc(c.co) : '') + '<br>' + esc(c.e) + (c.ph ? ' · ' + esc(c.ph) : '') + (c.cn ? ' · ' + esc(c.cn) : '') + '</p>' : '';
    var terms = snap.m ? 'Logo mould: already with us · Production: 14 days'
      : 'Logo mould (one-off): ' + eur(MOULD) + ', ready in about 1 week · Production: about 30 days in total, mould included';
    return '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Private label collection - Massimo Castelli - ' + esc(snap.d) + '</title><style>' +
      '@page{size:A4;margin:14mm}*{box-sizing:border-box}body{font-family:Helvetica,Arial,sans-serif;color:#111;margin:0;font-size:11pt;background:#fff}' +
      '.wrap{max-width:820px;margin:0 auto;padding:' + (viewer ? '24px 16px 40px' : '0') + '}' +
      '.bar{display:flex;justify-content:flex-end;gap:10px;margin:0 0 18px}.bar button{font:inherit;font-size:10.5pt;border:1px solid #111;background:#111;color:#fff;border-radius:999px;padding:8px 16px;cursor:pointer}.bar button.g{background:#fff;color:#111}' +
      '@media print{.bar{display:none}.wrap{padding:0}}' +
      'header{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:8px;margin-bottom:14px}' +
      'h1{font-size:20pt;font-weight:500;letter-spacing:.04em;margin:0}.sub{font-size:10pt;opacity:.65;margin:4px 0 0}.dt{font-size:10pt;text-align:right}' +
      '.cu{font-size:10pt;line-height:1.5;background:#f6f3ef;padding:8px 12px;margin:0 0 14px}' +
      'table{width:100%;border-collapse:collapse}th{text-align:left;font-size:8.5pt;text-transform:uppercase;letter-spacing:.06em;opacity:.6;font-weight:500;border-bottom:1px solid #ccc;padding:6px}' +
      'td{border-bottom:1px solid #e5e5e5;padding:8px 6px;vertical-align:middle}tr{page-break-inside:avoid}' +
      '.n{width:22px;opacity:.6}.im{width:110px}.im img{width:100px;height:100px;object-fit:contain;display:block}.q{white-space:nowrap;text-align:right}' +
      '.m{opacity:.65;font-size:9.5pt}i{display:inline-block;width:10px;height:10px;border-radius:50%;margin-right:5px;vertical-align:middle;border:1px solid rgba(0,0,0,.15)}' +
      '.tot{display:flex;justify-content:flex-end;gap:24px;font-size:11pt;margin-top:12px;flex-wrap:wrap}.pn{text-align:right;font-size:9pt;opacity:.7;margin:6px 0 0}' +
      '.tm{text-align:right;font-size:10pt;margin:10px 0 0}.tm b{font-weight:600}' +
      'footer{margin-top:22px;font-size:8.5pt;opacity:.6;border-top:1px solid #ddd;padding-top:8px}' +
      '</style></head><body><div class="wrap">' +
      (viewer ? '<div class="bar"><button type="button" class="g" onclick="parent.MCCollection.closeView()">Close</button><button type="button" onclick="window.print()">Print / Save PDF</button></div>' : '') +
      '<header><div><h1>MASSIMO CASTELLI</h1><p class="sub">Private label collection · quote request</p></div><div class="dt">' + esc(snap.d) + '</div></header>' +
      whoH +
      '<table><thead><tr><th></th><th>Photo</th><th>Model</th><th>Leather · colour</th><th>Logo</th><th style="text-align:right">Qty</th>' + (snap.pr ? '<th style="text-align:right">Base price</th><th style="text-align:right">Subtotal</th>' : '') + '</tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div class="tot"><span>' + snap.i.length + (snap.i.length === 1 ? ' item' : ' items') + '</span><b>Total: ' + t.pcs + ' pcs</b>' + (snap.pr && t.base ? '<b>Base total: ' + eur(t.base) + (t.miss ? ' + items on request' : '') + '</b>' : '') + '</div>' +
      (snap.pr ? '<p class="pn">' + PNOTE + '</p>' : '') +
      '<p class="tm">' + terms + (snap.pr && t.base && !snap.m ? '<br><b>Estimated total with mould: ' + eur(t.base + MOULD) + '</b>' : '') + '</p>' +
      '<footer>Indicative selection, not an order. Final prices are confirmed in our quote. · massimocastelli.it</footer>' +
      '</div></body></html>';
  }

  /* drawer button: opens the browser print dialog (print or "Save as PDF") */
  function printColl() {
    if (!coll.length) return;
    var html = pageHtml(snapshot(), false);
    var old = document.getElementById('mcc-print-frame'); if (old) old.parentNode.removeChild(old);
    var fr = document.createElement('iframe');
    fr.id = 'mcc-print-frame'; fr.setAttribute('aria-hidden', 'true');
    fr.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
    document.body.appendChild(fr);
    var doc = fr.contentWindow.document; doc.open(); doc.write(html); doc.close();
    var done = false;
    function go() { if (done) return; done = true; try { fr.contentWindow.focus(); fr.contentWindow.print(); } catch (e) {} }
    var imgs = doc.images, left = imgs.length;
    if (!left) { setTimeout(go, 50); return; }
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.complete) { if (--left === 0) go(); }
      else { im.onload = im.onerror = function () { if (--left === 0) go(); }; }
    });
    setTimeout(go, 4000);
  }

  /* link in the request email (https://massimocastelli.it/#mcc=...): shows the same printable collection full screen */
  function openFromLink() {
    var m = /[#&]mcc=([A-Za-z0-9_-]+)/.exec(location.hash || ''); if (!m) return;
    var snap; try { snap = JSON.parse(b64d(m[1])); } catch (e) { return; }
    if (!snap || !snap.i) return;
    var fr = document.createElement('iframe');
    fr.id = 'mcc-view'; fr.className = 'mcc-view'; fr.title = 'Private label collection';
    document.body.appendChild(fr);
    var doc = fr.contentWindow.document; doc.open(); doc.write(pageHtml(snap, true)); doc.close();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeView() {
    var fr = document.getElementById('mcc-view'); if (fr) fr.parentNode.removeChild(fr);
    document.documentElement.style.overflow = '';
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
  }

  function open() { var e = window.MCCollection._els; if (!e) return; e.ov.classList.add('is-open'); e.dr.classList.add('is-open'); }
  function close() { var e = window.MCCollection._els; if (!e) return; e.ov.classList.remove('is-open'); e.dr.classList.remove('is-open'); justSent = false; }
  function add(it) {
    coll.push(it); save(coll); justSent = false; render();
    var e = window.MCCollection._els;
    if (e) { e.fab.classList.remove('is-bump'); void e.fab.offsetWidth; e.fab.classList.add('is-bump'); }
  }
  function remove(i) { coll.splice(i, 1); save(coll); render(); }

  window.MCCollection = {
    get: function () { return coll.slice(); }, add: add, remove: remove, open: open, close: close, closeView: closeView,
    onChange: function (fn) { listeners.push(fn); fn(coll); }, _els: null
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
